import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const PredictionChart = ({ historicalData, predictions }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    
    if (!historicalData || !predictions) {
      return;
    }
    
    const ctx = chartRef.current.getContext('2d');
    
    // Prepare historical data
    const historicalLabels = historicalData.map(item => item.day);
    const historicalValues = historicalData.map(item => item.hours);
    
    // Prepare prediction data
    const predictionLabels = predictions.map(item => item.day);
    const predictionValues = predictions.map(item => item.hours);
    
    // Combine labels and create datasets
    const allLabels = [...historicalLabels, ...predictionLabels];
    
    // Create historical dataset with null padding for prediction period
    const historicalDataset = [
      ...historicalValues,
      ...Array(predictionLabels.length).fill(null)
    ];
    
    // Create prediction dataset with null padding for historical period
    const predictionDataset = [
      ...Array(historicalLabels.length).fill(null),
      ...predictionValues
    ];
    
    chartInstance.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels: allLabels,
        datasets: [
          {
            label: 'Historical Data',
            data: historicalDataset,
            backgroundColor: 'rgba(79, 70, 229, 0.2)',
            borderColor: 'rgba(79, 70, 229, 1)',
            borderWidth: 2,
            pointRadius: 4,
            pointBackgroundColor: 'rgba(79, 70, 229, 1)',
            tension: 0.1,
          },
          {
            label: 'Predicted Data',
            data: predictionDataset,
            backgroundColor: 'rgba(236, 72, 153, 0.2)',
            borderColor: 'rgba(236, 72, 153, 1)',
            borderWidth: 2,
            borderDash: [5, 5],
            pointRadius: 4,
            pointBackgroundColor: 'rgba(236, 72, 153, 1)',
            tension: 0.1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
          },
          legend: {
            position: 'top',
            labels: {
              usePointStyle: true,
              boxWidth: 10,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Hours',
            },
            ticks: {
              callback: function(value) {
                return value + 'h';
              }
            }
          },
          x: {
            grid: {
              display: false,
            },
          },
        },
        animation: {
          duration: 1000,
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
      },
    });
    
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [historicalData, predictions]);
  
  return (
    <div className="w-full h-full min-h-[300px]">
      <canvas ref={chartRef}></canvas>
      {(!historicalData || !predictions) && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">Insufficient data for prediction</p>
        </div>
      )}
    </div>
  );
};

export default PredictionChart; 